// Every word the player can read, in the language it was written in.
//
// This file is the source of truth. i18n.js falls back to it for any key another
// language has not translated yet, so a half-finished translation shows English in
// the gaps rather than blanks or raw keys — and adding a language is one file and
// no code at all.
//
// Keys are flat and dotted on purpose: `ach.veteran.name` reads the same in every
// table, and a grep for the key finds both the call site and the translation.

export default {
  // --- chrome --------------------------------------------------------------
  // La descripción que sale en Google y al pegar el enlace en un chat. Vive aquí y no escrita
  // en el HTML porque el HTML se genera por idioma en el build (ver tools/prerender-langs.mjs).
  'seo.description': 'The classic banana-throwing game, rebuilt and multiplayer: turn-based artillery over a neon skyline. Against the CPU, on one keyboard, or with a code on each other\'s phone. Free, in six languages.',
  'app.tagline': 'The classic banana-throwing game, rebuilt and multiplayer.',
  'app.footer': 'Made by Mendo Network, with love and plenty of nostalgia.',
  'ad.label': 'Advertising',
  'ad.tag': 'ADVERT',
  'app.canvasLabel': 'Battlefield: neon skyline with two gorillas throwing bananas',
  'app.language': 'LANGUAGE',

  'title.start': '▶ PLAY NOW',
  'title.join': '▶ JOIN',

  'menu.title': 'MAIN MENU',
  'menu.resume': '▶ BACK TO MATCH',
  'menu.newMatch': '▶ NEW MATCH',
  'menu.play': '▶ NEW MATCH',
  'menu.characters': '🎨 CHARACTER',
  'menu.leaderboards': '🏆 LEADERBOARDS',
  'menu.back': '← BACK TO THE TITLE',
  'menu.awards': '🏆 AWARDS',

  'setup.title': 'MATCH SETUP',
  'setup.mode': 'MODE',
  'setup.players': 'PLAYERS',
  'setup.turn': 'TURN TIME',
  'setup.noLimit': 'NO LIMIT',
  'setup.target': 'MATCH ROUNDS',
  'setup.onePlayer': '🤖 1 PLAYER',
  'setup.twoPlayers': '👥 2 PLAYERS',
  'setup.back': '← BACK',
  'setup.start': '▶ START MATCH',

  'pause.title': 'PAUSED',
  'pause.turn': '{name} TO THROW',
  'pause.resume': '▶ RESUME',
  'pause.restart': '↻ RESTART',
  'pause.setup': '🎮 SETTINGS',
  'pause.share': '🔗 INVITE',
  'pause.home': '🚪 END THE MATCH',
  'pause.menu': '⌂ BACK TO MAIN MENU',
  'pause.music': 'MUSIC',
  'pause.fx': 'EFFECTS',
  'setup.against': 'THE OTHER SIDE',
  'setup.againstCpu': '🤖 THE CPU',
  'setup.againstRandom': '🎲 RANDOM RIVAL',
  'pool.waiting': '{n} WAITING',
  'pool.playing': '{n} PLAYING · {w} WAITING',
  'pool.none': 'NOBODY IS WAITING RIGHT NOW',
  'pool.noserver': 'NO SERVER · YOU WILL PLAY THE CPU',
  'search.title': 'LOOKING FOR A RIVAL',
  'search.empty': 'THE QUEUE IS EMPTY · YOU WILL PLAY THE CPU',
  'search.seconds': '{n} s',
  'search.matched': '{name} HAS ARRIVED',
  'search.cpu': '🤖 PLAY THE CPU',
  'search.cancel': '✖ CANCEL',
  'special.sheep.name': 'SHEEP',
  'special.sheep.hint': 'Hops by itself and blows.',
  'play.fireSheep': '🐑 SHEEP!',
  'bubble.sheep': 'BAAA!',
  'char.you': 'YOU',
  'char.rival': 'RIVAL',
  'hud.vsOnline': 'VS {name}',
  'music.on': 'MUSIC ON',
  'music.off': 'MUSIC OFF',
  'pause.button': 'Pause',

  'results.over': 'MATCH OVER',
  'results.wins': '{name} WINS',
  'results.rematch': '▶ REMATCH',

  // --- the header and the play bar ----------------------------------------
  'hud.vsCpu': 'VS CPU',
  'hud.twoPlayer': '2 PLAYER',
  'hud.firstTo': 'FIRST TO',
  'hud.round': 'ROUND {n}',
  'hud.noRound': 'ROUND —',
  'hud.p1': 'P1',
  'hud.p2': 'P2',
  'hud.cpu': 'CPU',
  'hud.wind': 'WIND',

  'play.angle': 'ANGLE',
  'play.power': 'POWER',
  'play.fire': 'THROW',
  'play.waiting': 'WAITING FOR THE RIVAL',
  'play.fireBall': 'THROW BALL',
  'play.fireGrenade': 'THROW GRENADE',
  'play.fireLeap': 'LEAP AND THROW',
  'play.fireShield': 'RAISE SHIELD',
  'play.fireSpring': 'GET ON THE SPRING',
  'play.fireMushroom': 'KEEP THE MUSHROOM',


  // --- the special button --------------------------------------------------
  'special.none': '✦ SPECIAL: NONE',
  'special.spent': '✦ SPECIAL: SPENT',
  'special.locked': '✦ SPECIAL: LOCKED',
  'special.off': 'SPECIALS OFF',
  'special.chosen': '✦ {name} × {n}',

  // --- panels --------------------------------------------------------------
  'loadout.title': '🎒 EQUIPMENT',
  'loadout.note': 'What you carry. What you pick is what your next throw does; a protection is put up with the shield button instead. (I opens this.)',
  'intro.welcome': '{n} ABILITIES READY — ⚔ ATTACK PICKS ONE',
  'loadout.next': 'Kept for your next turn.',
  'loadout.ults': 'SPECIAL ATTACKS',
  'loadout.guards': 'DEFENCES',
  'loadout.howto': 'Achievement: {name}',
  'loadout.off': 'No special attacks or defences in this mode: CLASSIC is the original game.',
  'special.attack': '⚔ ATTACK',
  'special.guard': '🛡 DEFENCE',
  'announce.round': 'ROUND {n}',
  'announce.fight': 'FIGHT!',
  'announce.turn': 'YOUR TURN — {name}',
  'splash.tapForMusic': 'TAP TO HEAR MUSIC',
  'char.title': '🎨 CHARACTERS',
  'char.close': '✕ CLOSE',
  'char.save': '✓ SAVE',
  'char.note': 'Species and accessories. A wider animal is a wider target, and a top hat is a slightly larger head: the picture is the hitbox.',
  'char.player1': 'PLAYER 1',
  'char.player2': 'PLAYER 2',
  'slot.hat': 'HAT',
  'slot.face': 'FACE',
  'slot.neck': 'NECK',

  'award.title': '🏆 AWARDS',
  'award.close': '✕ CLOSE',
  'award.progress': '🏆 AWARDS {n}/{total}',
  'award.rewardAntic': '+ GESTURE {name}',
  'award.rewardSpecial': '+ SPECIAL {name}',

  'rank.title': '🏆 LEADERBOARDS',
  'rank.close': '✕ CLOSE',
  'rank.name': 'YOUR NICKNAME',
    'rank.namePlaceholder': 'Type your nick here to play',
  'rank.online': 'ONLINE — BEST FIRST',
  'rank.refresh': '↻ REFRESH',
  'rank.local': 'ON THIS MACHINE',
  'rank.emptyLocal': 'Nothing yet. Finish a match and it lands here.',
  'rank.emptyOnline': 'Nothing on the board yet. Be the first.',
  'rank.checking': 'Checking…',

  'share.close': 'CLOSE',
  'share.generate': 'INVITE TO A MATCH',
  'share.placeholder': 'Your code appears here',
  'share.copied': 'Copied. Send it to whoever you want to invite.',
  'join.placeholder': 'I HAVE A CODE',
  'join.title': 'JOIN A MATCH',
  'join.label': 'Match code',

  'lang.title': 'LANGUAGE',
  'lang.note': 'English is the original. Everything else is a translation of it.',

  // --- shared match codes --------------------------------------------------
  'code.noCode': 'Paste a code first.',
  'code.tooLong': 'That is far too long to be a match code.',
  'code.notACode': 'That does not look like a match code.',
  'code.version': 'That code is from a different version.',
  'code.corrupt': 'Corrupt code.',
  'code.mode': 'That code names a mode this build does not have.',

  // --- the shared board ----------------------------------------------------
  'lb.checking': 'asking the server…',
  'lb.online': 'shared board, live',
  'lb.noServer': 'no ranking server here',
  'lb.timeout': 'the server did not answer in time',

  // --- what the gorillas shout --------------------------------------------
  'bubble.fireInTheHole': 'FIRE IN THE HOLE!',
  'bubble.leap': 'COMING THROUGH!',
  'bubble.uavOnline': 'ENEMY UAV ONLINE',
  'bubble.headshot': 'BOOM, HEADSHOT!',
  'bubble.extraLife': 'EXTRA LIFE!',
  'bubble.mushroomSaved': 'THE MUSHROOM TOOK IT!',
  'bubble.boomerangBack': 'IT CAME BACK!',
  'bubble.boomerangLost': 'IT NEVER CAME BACK',

  // --- the caption after a kill -------------------------------------------
  'wasted.subtitle': 'The wind does not care about your plans.',

  // --- the sky -------------------------------------------------------------
  'banner.0': 'EAT MORE BANANAS',
  'banner.1': 'GO APE!',
  'banner.2': 'BANANA FOR PRESIDENT',
  'banner.3': 'THIS BANNER IS A LIE',
  'banner.4': 'SEND BANANAS',
  'banner.5': 'MISSED ME AGAIN',
  'banner.6': 'FREE HUGS',
  'banner.7': "HELP, I'M IN A GAME",
  'banner.8': 'VICE CITY — 4 MINUTES AWAY',
  'banner.9': 'LEONIDA: THE OTHER FLORIDA',
  'banner.10': 'COMING 2027. PROBABLY.',

  // --- the splash ----------------------------------------------------------
  'tip.0': 'TIP: THE WIND DOES NOT CARE ABOUT YOUR PLANS.',
  'tip.1': 'TIP: THE PREVIEW NEVER COUNTS THE WIND. THAT IS THE POINT.',
  'tip.2': 'TIP: A BANANA THAT COMES BACK DOWN IS STILL A BANANA.',
  'tip.3': 'TIP: A GRENADE DOES NOT NEED TO HIT ANYBODY.',
  'tip.4': 'TIP: IF THE OTHER GORILLA IS ASLEEP, SHOOT.',
  'tip.5': 'TIP: SOMEONE HAS TO CLEAN UP THAT SKYLINE.',

  // --- species -------------------------------------------------------------
  'species.gorilla': 'GORILLA',
  'species.chimp': 'CHIMP',
  'species.orangutan': 'ORANGUTAN',
  'species.baboon': 'BABOON',
  'species.panda': 'PANDA',
  'species.bear': 'BROWN BEAR',
  'species.rhino': 'RHINO',
  'species.bonobo': 'BONOBO',
  'species.gibbon': 'GIBBON',
  'species.mandrill': 'MANDRILL',
  'species.hippo': 'HIPPO',
  'species.duck': 'DUCK',
  'species.frog': 'FROG',

  // --- accessories ---------------------------------------------------------
  'accessory.cap': 'BALL CAP',
  'accessory.beanie': 'BEANIE',
  'accessory.tophat': 'TOP HAT',
  'accessory.crown': 'CROWN',
  'accessory.viking': 'VIKING HELM',
  'accessory.bow': 'PINK BOW',
  'accessory.shades': 'SHADES',
  'accessory.patch': 'EYE PATCH',
  'accessory.scarf': 'SCARF',
  'accessory.bowtie': 'BOW TIE',
  'accessory.chain': 'GOLD CHAIN',

  // --- gestures ------------------------------------------------------------
  'antic.scratch': 'SCRATCH',
  'antic.head': 'HEAD SCRATCH',
  'antic.chest': 'CHEST BEAT',
  'antic.wave': 'WAVE',
  'antic.pick': 'NOSE PICK',
  'antic.shrug': 'SHRUG',
  'antic.stretch': 'STRETCH',
  'antic.shake': 'SHAKE OFF',
  'antic.clap': 'CLAP',
  'antic.flex': 'FLEX',

  // --- modes ---------------------------------------------------------------
  'mode.modern.name': 'MODERN',
  'mode.modern.blurb': 'Specials, antics, sky and achievements.',
  'mode.classic.name': 'CLASSIC',
  'mode.classic.blurb': 'No specials, no antics, no sky, no achievements.',
  'mode.demolition.name': 'DEMOLITION',
  'mode.demolition.blurb': 'Craters that bring a whole tower down.',
  'mode.lunar.name': 'LUNAR GRAVITY',
  'mode.lunar.blurb': 'A third of the pull.',
  'mode.weather.name': 'WEATHER',
  'mode.weather.blurb': 'Rain, snow and gusts.',
  'mode.quake.name': 'EARTHQUAKE',
  'mode.quake.blurb': 'The buildings rise and fall under your feet.',

  // --- specials ------------------------------------------------------------
  'special.flare.name': 'FLARE',
  'special.flare.hint': 'Preview reaches twice as far.',
  'special.heavy.name': 'HEAVY',
  'special.heavy.hint': 'The wind barely moves it.',
  'special.fat.name': 'WIDE LOAD',
  'special.fat.hint': 'A much bigger crater.',
  'special.lunar.name': 'LUNAR',
  'special.lunar.hint': 'No wind. Huge crater.',
  'special.grenade.name': 'GRENADE',
  'special.grenade.hint': 'Bounces and blows on a fuse.',
  'special.drone.name': 'DRONE',
  'special.drone.hint': 'Flies over and marks them.',
  'special.leap.name': 'THE LEAP',
  'special.leap.hint': "Jumps to the rival's spot.",
  'special.shield.name': 'SHIELD',
  'special.shield.hint': 'Stops one rival shot.',
  'social.title': 'TELL SOMEONE',
  'social.whatsapp': 'Share on WhatsApp',
  'social.telegram': 'Share on Telegram',
  'social.facebook': 'Share on Facebook',
  'social.x': 'Share on X',
  'social.instagram': 'Send to Instagram — opens your phone\u2019s share sheet',
  'social.copy': 'Copy the link',
  'toast.copied': '🔗 Link copied',
  'toast.copyFailed': 'The browser would not let me copy it',
  'special.pick': 'PICK ONE',
  'special.spring.name': 'SPRING',
  'special.spring.hint': 'Get on it and dance.',
  'special.mushroom.name': 'MUSHROOM',
  'special.mushroom.hint': 'Takes the hit that kills you.',

  'toast.crateSpecial': '📦 {name} +1 — yours next round too',
  'toast.crateTheirs': '📦 {who} takes {name}',
  'toast.crateLife': '❤ EXTRA LIFE — you survive one more hit',
  'toast.crateLifeTheirs': '❤ {who} takes an extra life',
  'toast.award': '🏆 ACHIEVEMENT! {names}',
  'setup.cpu': 'CPU DIFFICULTY',
  'setup.cpuEasy': 'EASY',
  'setup.cpuNormal': 'NORMAL',
  'setup.cpuHard': 'HARD',
  'rotate.title': 'TURN THE PHONE',
    'rotate.body': 'The match is played sideways: turn the phone on its side to carry on.',
  'setup.duel': 'HOW YOU TWO PLAY',
  'duel.code': '🔗 EACH ON A PC / PHONE',
  'duel.hotseat': '⌨️ SAME COMPUTER',
  'share.waiting': 'Send them the code. They send one back.',
  'share.invite': 'Copy the code and send it to whoever you want to invite.',
  'share.joined': 'You are in. You play first.',
  'share.roomOpen': 'The room is open: this code is the door, and you two play live, with no codes to pass between turns.',
  'share.roomBack': 'Your rival is in.',
  'share.roomGone': 'Your rival has left. The room stays open and the seat is free.',
  'share.roomLost': 'The connection went. The match carries on on this machine.',
  'code.inviteLength': 'An invitation code is 8 characters, 4 and 4.',
  'code.inviteLetters': 'That code has a character that cannot be in one.',
  'code.inviteCheck': 'That code does not add up: check a letter.',
  'special.ball.name': 'THE BALL',
  'special.ball.hint': 'Sometimes it is a ball.',
  'special.boomerang.name': 'BOOMERANG',
  'special.boomerang.hint': 'Comes back to your hand and keeps the charge.',
  'toast.ball': '{icon} {name}!',
  'ball.basket': 'BASKETBALL',
  'ball.football': 'FOOTBALL',
  'ball.rugby': 'RUGBY BALL',
  'ball.tennis': 'TENNIS BALL',

  // --- achievements --------------------------------------------------------
  'ach.first-blood.name': 'FIRST BLOOD',
  'ach.first-blood.hint': 'Land your first banana.',
  'ach.round-won.name': 'ROUND WON',
  'ach.round-won.hint': 'Win a round.',
  'ach.butterfingers.name': 'BUTTERFINGERS',
  'ach.butterfingers.hint': 'Hitting yourself counts too.',
  'ach.sharpshooter.name': 'SHARPSHOOTER',
  'ach.sharpshooter.hint': 'Land three hits in a row.',
  'ach.match-won.name': 'MATCH WON',
  'ach.match-won.hint': 'Win a match.',
  'ach.cpu-slayer.name': 'CPU SLAYER',
  'ach.cpu-slayer.hint': 'Win a match against the CPU.',
  'ach.moon-shot.name': 'MOON SHOT',
  'ach.moon-shot.hint': 'Pass a banana across the face of the moon.',
  'ach.sky-watcher.name': 'SKY WATCHER',
  'ach.sky-watcher.hint': 'Catch three different things crossing the sky.',
  'ach.flawless.name': 'FLAWLESS',
  'ach.flawless.hint': 'Win a match without dropping a single round.',
  'ach.veteran.name': 'VETERAN',
  'ach.veteran.hint': 'Win three matches.',
  'ach.thrower.name': 'HURLER',
  'ach.thrower.hint': 'Throw 50 bananas.',
  'ach.rounds-10.name': 'TEN ROUNDS',
  'ach.rounds-10.hint': 'Win ten rounds.',
  'ach.sharpshooter-plus.name': 'EAGLE EYE',
  'ach.sharpshooter-plus.hint': 'Land six hits in a row.',
  'ach.moon-3.name': 'ASTROPHYSICIST',
  'ach.moon-3.hint': 'Pass a banana across the face of the moon three times.',
  'ach.cpu-3.name': 'FIRED UP',
  'ach.cpu-3.hint': 'Beat the CPU three times.',
  'ach.flawless-3.name': 'UNTOUCHABLE',
  'ach.flawless-3.hint': 'Win three matches without dropping a round.',
  'ach.veteran-2.name': 'LEGEND',
  'ach.veteran-2.hint': 'Win five matches.',
  'ach.scavenger.name': 'SCAVENGER',
  'ach.scavenger.hint': 'Break open five crates.',
  'ach.wall.name': 'THE WALL',
  'ach.wall.hint': 'Raise your shield five times.',
  'ach.arsenal.name': 'ARSENAL',
  'ach.arsenal.hint': 'Use six different specials.',
  'ach.bare-handed.name': 'BARE-HANDED',
  'ach.bare-handed.hint': 'Win a match without spending a thing.',
  'ach.room-won.name': 'LIVE',
  'ach.room-won.hint': 'Win a match in a room.',
  'ach.room-3.name': 'NEIGHBOURHOOD',
  'ach.room-3.hint': 'Win three matches in rooms.',
  'ach.by-mail.name': 'BY POST',
  'ach.by-mail.hint': 'Win a duel by code.',
  'ach.boomerang-back.name': 'COMEBACK',
  'ach.boomerang-back.hint': 'Catch your own boomerang three times.',
};
